import * as React from 'react'
import * as Cookies from 'js-cookie'

import { useSiteConfig } from '@thg-commerce/enterprise-core'
import { BreakpointArray } from '@thg-commerce/gravity-theme'
import { Orientation } from '@thg-commerce/gravity-patterns/ImageGallery/types'
import { QubitBadge } from '@thg-commerce/enterprise-pages/src/Product/theme'

import {
  QubitBadgeProps,
  QubitUrgencyMessaging,
  QubitUrgencyMessagingContainer,
} from './QubitUrgencyMessaging'

export type QubitUrgencyMessagingRendererProps = Omit<
  QubitBadgeProps,
  'placementId'
> & {
  isGrid?: boolean
  orientation: BreakpointArray<Orientation>
  isFullWidth: boolean
  isFullWidthOnDesktop: boolean
  horizontalAlignment: 'left' | 'center' | 'right'
  verticalAlignment?: { desktop?: number; mobile?: number }
  qubitBadgeMessagingStyle?: QubitBadge
}

export const QubitUrgencyMessagingRenderer = (
  props: QubitUrgencyMessagingRendererProps,
) => {
  const { qubit } = useSiteConfig()
  const [showBadge, setShowBadge] = React.useState<boolean>(true)

  if (
    !qubit?.enabled ||
    !qubit?.placements?.urgencyMessagingId ||
    !Cookies.get('_qubitTracker') ||
    !showBadge
  ) {
    return null
  }

  return (
    <QubitUrgencyMessagingContainer
      isGrid={!!props.isGrid}
      orientation={props.orientation}
      isFullWidth={props.isFullWidth}
      horizontalAlignment={props.horizontalAlignment}
      verticalAlignment={props.verticalAlignment}
      showCloseButton={qubit.showUrgencyMsgCloseButton}
      qubitBadgeMessagingStyle={props.qubitBadgeMessagingStyle}
    >
      <QubitUrgencyMessaging
        {...props}
        placementId={qubit.placements.urgencyMessagingId}
        setShowBadge={setShowBadge}
      />
    </QubitUrgencyMessagingContainer>
  )
}
